import { render, staticRenderFns } from "./ProductionMultiForm.vue?vue&type=template&id=5b11aafb&"
import script from "./ProductionMultiForm.vue?vue&type=script&lang=js&"
export * from "./ProductionMultiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports